/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import {
  AutozoneLogo,
  Icon,
  Link as StarcLink,
  Text,
  User,
  View,
} from '@az/starc-ui'
import { FC } from 'react'
import { CustomMenu } from '../CustomMenu/CustomMenu'
import { useAuth } from '../../shared/Auth2.0/useAuth'
// import Manifset from '../../../public/manifest.json'

interface HeaderProps {
  height?: string
  disabled?: boolean
}

// const release = Manifset.version

const ENABLE_DEV_MODE = window.env.VITE_ENABLE_DEV_MODE === true

export const Header: FC<HeaderProps> = ({ height = '100%' }) => {
  // TODO: temporary until this is automated via CI:

  const { user, logout } = useAuth()

  const handleLogout = () => {
    logout()
  }

  const menuTriggerComplex = (
    <View padding={3} align="center" className="qa-view-Header mcp-scroll-to-target-header">
      <View direction="row" align="center">
        <Icon svg={User} />
        <View width="16px" />
        <View direction="column">
          <Text variant="subtitle-bold" color="600">
            My Account
          </Text>
          <Text variant="subtitle-bold" color="success">
            {user?.completeName} | ECOMM
          </Text>
        </View>
      </View>
    </View>
  )

  return (
    <View direction="column">
      <View
        direction="row"
        align="center"
        shadow="small"
        backgroundColor="secondary"
        height={height}
        attributes={{
          style: {
            borderBottom: '1px solid var(--st-color-gray-300)',
          },
        }}
      >
        <View.Item grow>
          <View padding={[0, 4]}>
            <View direction="row" align="center" gap={4}>
              <View.Item>
                <AutozoneLogo size={4} variant="full" />
              </View.Item>
              <View.Item>
                {/* <Text variant="display-4">Merch Config Portal - {release}</Text> */}
              </View.Item>
            </View>
          </View>
        </View.Item>
        <View padding={[0, 4]}>
          <View direction="row" align="center">
            
            <View.Item>
              <CustomMenu menuTriggerLabel={menuTriggerComplex} id="user-menu-collapsible">
                <View padding={4}>
                  <StarcLink
                    variant="plain"
                    className="user-menu-logout-opt"
                    onClick={handleLogout}
                  >
                    Logout
                  </StarcLink>
                </View>
              </CustomMenu>
            </View.Item>
          </View>
        </View>
      </View>

    </View>
  )
}
